import { Component, Input } from "@angular/core"
import { NgForm } from "@angular/forms"
import { NgbTypeaheadSelectItemEvent } from "@ng-bootstrap/ng-bootstrap"
import { ExternalSearchInputComponent } from "../../../../shared-components/external-search-input/external-search-input.component"
import { Observable } from "rxjs"
import Utils from "../../../../utils/utils"

@Component({
    selector: "app-search-collection-input",
    templateUrl: "./search-collection-input.component.html",
    styleUrls: ["./search-collection-input.component.scss"],
    standalone: false,
})
export class SearchCollectionInputComponent extends ExternalSearchInputComponent {
    @Input() public image: string = ""
    @Input() public collection: string = ""
    isInPreviewMode$: boolean

    ngOnInit() {
        super.ngOnInit()
        this.isInPreviewMode$ = Utils.isPreviewMode()
    }

    public onSearch(form: NgForm) {
        const queryParams = form.value
        this.router.navigate(["collection", this.collection, "search"], {
            queryParamsHandling: "merge",
            queryParams,
        })
        this._pressedEnter = true
        this.gtmService.pushSearchEvent("collection-search", form.value.q)
    }

    public onSelectItem(form: NgForm, event: NgbTypeaheadSelectItemEvent) {
        const queryParams = { q: event.item.title, selected_facet: [] }
        if (event.item.subject) {
            queryParams.selected_facet.push(
                this.facetingService.makeSubjectQueryParam(event.item.subject.id)
            )
        }
        if (event.item.grade) {
            queryParams.selected_facet.push(
                this.facetingService.makeGradeQueryParam(event.item.grade)
            )
        }
        this.router.navigate(["collection", this.collection, "search"], {
            queryParamsHandling: "merge",
            queryParams,
        })
        this.gtmService.pushSearchEvent("collection-search", form.value.q)
    }
}
